import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appNoSpecialChars]',
    standalone: false
})
export class NoSpecialCharsDirective {
  // Regular expression to allow only letters, numbers, and spaces
  private readonly NO_SPECIAL_CHARS_REGEXP = /^[a-zA-Z0-9\s]*$/;
  constructor() { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const enteredKey = event.key;
    // Allow only letters, numbers, and spaces, and also allow control keys
    if (!this.NO_SPECIAL_CHARS_REGEXP.test(enteredKey)) {
      event.preventDefault(); // Prevent typing special characters
    }
  }
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData.getData('text');
    // Check if pasted text contains only allowed characters
    if (!this.NO_SPECIAL_CHARS_REGEXP.test(pastedText)) {
      event.preventDefault(); // Prevent pasting special characters
    }
  }
}
